(() => {
  const examples = {
    '10888585249073': 'the Dune omnibus binding examples pictured',
    '10887378960689': 'the Dune binding example pictured',
    '10887378796849': 'the classic Narnia binding example pictured',
    '10887378895153': 'Fourth Wing'
  };
  const potter = {
    '10888029471025': "Harry Potter and the Philosopher's Stone",
    '10888029143345': 'Harry Potter and the Chamber of Secrets',
    '10888029241649': 'Harry Potter and the Prisoner of Azkaban',
    '10888029307185': 'Harry Potter and the Goblet of Fire',
    '10888029339953': 'Harry Potter and the Order of the Phoenix',
    '10888029405489': 'Harry Potter and the Half-Blood Prince',
    '10888029438257': 'Harry Potter and the Deathly Hallows'
  };
  const identities = {
    '10888029471025': { source: '4597103328', choice: /philosopher/i },
    '10888029143345': { source: '4597113710', choice: /chamber/i },
    '10888029241649': { source: '4597116844', choice: /prisoner|azkaban/i },
    '10888029307185': { source: '4597116922', choice: /goblet/i },
    '10888029339953': { source: '4597096561', choice: /phoenix/i },
    '10888029405489': { source: '4597096679', choice: /half.blood/i },
    '10888029438257': { source: '4597096753', choice: /deathly/i },
    '10888493072689': { source: '8734074405', additionalSources: ['8734065809'], choice: /fellowship/i },
    '10888493105457': { source: '8686255122', choice: /two towers/i },
    '10888493203761': { source: '8734066805', choice: /return.*king/i }
  };
  function init() {
    document.querySelectorAll('[data-native-product]').forEach(root => {
      if (root.dataset.photoStatusReady) return;
      const id = root.dataset.nativeProduct.split('/').pop();
      if (!examples[id] && !identities[id]) return;
      const scope = root.closest('dialog') || root;
      const gallery = scope.querySelector('.pa-edition-photos, .pa-book-gallery');
      const select = root.querySelector('[data-pa-variant], select[name="id"]');
      if (!gallery || !select) return;
      root.dataset.photoStatusReady = 'true';
      const note = document.createElement('p');
      note.className = 'pa-photo-status';
      note.style.cssText = 'font-size:13px;line-height:1.6;padding:12px 0;color:inherit;';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      gallery.after(note);
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        let selected;
        try { selected = JSON.parse(option.dataset.options || '[]')[0]; } catch (_) {}
        selected = selected || option.textContent.split(' / ')[0].split(/ [--] \$/)[0].trim();
        if (identities[id]) {
          const identity = identities[id];
          const complete = /complete|whole|\bset\b|collection|trilogy/i.test(selected);
          const matches = identity.choice.test(selected);
          let visible = 0;
          gallery.querySelectorAll('img').forEach(image => {
            const imageSource = image.getAttribute('src') || '';
            const own = [identity.source, ...(identity.additionalSources || [])].some(source => imageSource.includes(source));
            image.hidden = !complete && !own;
            if (!image.hidden) visible++;
          });
          note.hidden = matches && !complete && visible > 0;
          note.textContent = complete
            ? (potter[id] ? 'The gallery includes the individual covers of all seven volumes in the complete set.' : 'The gallery shows the three individual volume covers in the complete trilogy.')
            : note.hidden ? '' : `Photos show ${potter[id] || 'the pictured Tolkien volume'} as a binding example. A photograph verified for your selection (${selected}) has not been assigned to this preview yet.`;
          gallery.scrollLeft = 0;
          gallery.dispatchEvent(new Event('pa:gallery-change'));
        } else if (id === '10887378895153' && selected === 'Fourth Wing') {
          note.hidden = true;
          note.textContent = '';
        } else {
          note.hidden = false;
          note.textContent = `Photos show ${examples[id]}. A photograph verified for your selection (${selected}) has not been assigned to this preview yet.`;
        }
      };
      select.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
